export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del contenedor"])},
          "title_export_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas"])},
          "total_number_export_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas"])},
          "total_number_export_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas pagadas"])}
        }
      }
    }
  })
}